import styled from 'styled-components'

export const PageLayout = styled.div`
    display: flex;
    gap: 24px;
    width: 100%;
    flex-wrap: wrap;
`
